/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  SwipeableDrawer,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";

function RegisterDone(props) {
  const { closeRes } = props;
  axios.defaults.withCredentials = true; // 세션유지

  return (
    <Grid align="center">
      <Box>
        <Box css={css `margin-top:30px;font-weight:bold;`}>회원 가입이 완료되었습니다.</Box>
        <Button
          onClick={closeRes}
          variant="contained"
          css={css`
            font-size: 16px;
            margin-top:20px;
          `}
        >
          로그인 하기 
        </Button>
      </Box>
    </Grid>
  );
}

export default RegisterDone;
